import { get, put, post } from '../coreservices/apiService'
import * as environment from '../coreservices/environment'
export function abc() {
    return <div>abc</div>
}

export function get_footermaster() {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/footermaster`
    return get(url).then(response => {
        return response;
    })
}

export function get_imageslidermaster() {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/footermaster`
    return get(url).then(response => {
        return response;
    })
}

export function post_footermaster(data) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/footermaster`
    return post(url, data).then(response => {
        return response;
    })
}

export function put_footermaster(data) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/footermaster`
    return put(url, data).then(response => {
        return response;
    })
}

export function get_faqmaster_active() {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/faqmaster/active`;
    return get(url).then(response => {
        return response;
    });
}

export function search_faqmaster(query) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/faqmaster/search?q=${encodeURIComponent(query)}`;
    return get(url).then(response => {
        return response;
    });
}

export function get_imageslideruppermaster_active() {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/imageslideruppermaster/active`;
    return get(url).then(response => {
        return response;
    });
}